/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "dfe2539da76e194f60b72b597d4f1b2855660f14";
